import React, { useCallback, useEffect, useState } from 'react';
import './index.scss';
import Layout from "@/Hoc/Layout";
import Main from './Main';
import services from '@/services';
import uiData from '@/Data/i18n';
import tools from '@/libs/tools';
import useFramerEmotionConfig from '@/libs/useFramerEmotionConfig';
import { AnimatePresence, motion } from 'framer-motion';
import useMediaQuery from '@tevhooks/use-media-query';
import Loading from '@/Components/Loading';

const Page = (props) => {
    let { welcome } = uiData.getUiI18n().home;

    let [ showHomePage, updateShowHomePage ] = useState(false);
    let isMobile = useMediaQuery(query => query.down('mobile'));

    useEffect(() => {
        props.updateHeaderStyle(1);
        return () => props.updateHeaderStyle(null);
    }, []);
    
    const whenWheeled = useCallback(() => {
        !isMobile && props.updateHeaderStyle(2);
        updateShowHomePage(true);
    }, []);

    let [ tabs, updateTabs ] = useState([]);
    useEffect((currentSelectedSubMenuId) => {
        services.Home.fetchTab(currentSelectedSubMenuId).then(res => {
            updateTabs(res.data.data);
        });
    }, []);

    let background = isMobile ? welcome.mobileImg : welcome.pcImg;

    return (    
        <AnimatePresence>
            <div className="back-first-page" onClick={() => updateShowHomePage(false)}></div>
            {
                !showHomePage ? 
                    <HomeWelcome key={1} title={welcome.title} content={welcome.content} whenWheeled={whenWheeled} background={background} links={welcome.links || []} /> :
                    <Main key={2} tabs={tabs} />
            }
        </AnimatePresence>
    );
};

const HomeWelcome = (props) => {
    let [ isLoading, setLoading ] = useState(true);
    let [ background, setBackground ] = useState('');

    //  preload assets
    useEffect(() => {
        let img = new Image();
        img.addEventListener('load', () => {
            setBackground(props.background);
            setLoading(false);
        });
        img.crossOrigin = "Anonymous";
        img.src = props.background;
    }, [ props.background ]);
    

    useEffect(() => {
        let whenWheeling = () => props.whenWheeled && props.whenWheeled();
        tools.isTouchDevice() ? 
            document.body.addEventListener('touchmove', whenWheeling, { once: true }) :
            document.body.addEventListener('wheel', whenWheeling, { once : true });


        return (() => {
            tools.isTouchDevice() ? 
                document.body.removeEventListener('touchmove', whenWheeling) :
                document.body.removeEventListener('wheel', whenWheeling);
        });
    }, []);

    //  framer animation
    let framer = useFramerEmotionConfig({ 
        mobile: { 
            initial: { y: 3, opacity: 0 }, 
            animate: { y: 0, opacity: 1 }, 
            transition: { duration: 1.6, delay: .8 } 
        }, 
        laptop: {
            initial: { y: 20, opacity: 0 }, 
            animate: { y: 0, opacity: 1 }, 
            transition: { duration: 1.6, delay: .8 } 
        }
    });

    if (isLoading) return <Loading />;

    return (
        <div>
            <motion.div 
                className="home-welcome" 
                style={{ backgroundImage: `url('${background}')`}} 
                initial={{ opacity: 0 }} 
                exit={{ opacity: 0, transition: { duration: .75 } }} 
                animate={{ opacity: 1 }} transition={{ duration: 2.5 }}
            >
                {
                    framer && (
                        <div className="home-welcome-bd">
                            <motion.h1 className="title" initial={framer.initial} animate={framer.animate} transition={framer.transition}>{props.title}</motion.h1>
                            <motion.p className="content" initial={framer.initial} animate={framer.animate} transition={{ duration: 1.6, delay: 1.2 }}>{props.content}</motion.p>
                            <motion.span className="home-welcome-scroll-tips" initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.6, delay: 2 }}><i></i></motion.span>
                        </div>
                    )
                }
            </motion.div>

            <motion.div 
                initial={{ opacity: 0 }} 
                exit={{ opacity: 0, transition: { duration: .75 } }} 
                animate={{ opacity: 1 }} transition={{ duration: 2.5 }}
            >
                {
                    framer && (
                        <motion.ul className="out-links" initial={framer.initial} animate={framer.animate} transition={{ duration: 1.6, delay: 2 }}>
                            {
                                (props.links || []).map(link => <li><a href={link.url} target="_blank">{link.text}</a></li>)
                            }
                        </motion.ul>
                    )
                }
            </motion.div>
        </div>
    );
};

export default Layout({ name: 'home' })(Page);
